<section>
    <div class="modal-header">
        <h3>Agregar Garantías</h3>
        <button mat-icon-button (click)="closeDialog()" style="position: absolute; right: 10px;">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="modal-body">
        <section *ngIf="loading" style="display: flex; justify-content: center;">
            <mat-spinner diameter="70"></mat-spinner>
        </section>
        <section>
            <span class="no-content" *ngIf="dataSource.data.length == 0 && !loading">
                <h3>No hay garantías para agregar a la minuta</h3>
            </span>
            <div [hidden]="dataSource.data.length == 0">
                <div class="overflow-table">
                    <table mat-table matSort [dataSource]="dataSource">
                        <ng-container matColumnDef="selectionColumn">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element" >
                                <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(element) : null"
                                [checked]="selection.isSelected(element)">
                                </mat-checkbox>
                            </td>
                        </ng-container>
            
                        <!-- Finalidad -->
                        <ng-container matColumnDef="warrantyType">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Tipo
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.warrantyType}}</h6>
                            </td>
                        </ng-container>
            
                        <!-- Asegurador -->
                        <ng-container matColumnDef="insuranceCompany">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Aseguradora
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.insuranceCompany}}</h6>
                            </td>
                        </ng-container>
            
                        <!-- Fecha solicitud -->
                        <ng-container matColumnDef="createdAt">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Solic.
                            </th>
                            <td class="mat-body-1" mat-cell *matCellDef="let element">
                                <h6>{{element.createdAt | date : 'dd-MM-yyyy'}}</h6>
                            </td>
                        </ng-container>
            
                        <!-- Codigo Licitacion-->
                        <ng-container matColumnDef="tender">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Lic.
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.tender}}</h6>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="amount">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Monto
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.amount | currency : 'CLP'}}</h6>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="amountType">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Moneda
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.amountType}}</h6>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="cost">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Comisión
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.cost | currency : 'CLP'}}</h6>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="nameTenderBuyer">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Mandante
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.nameTenderBuyer}}</h6>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="requestDate">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Desde
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.requestDate | date : 'dd-MM-yyyy'}}</h6>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="endDate">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Hasta
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.endDate | date : 'dd-MM-yyyy'}}</h6>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="tasa">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Tasa (%)
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.tasa | number : '1.2-2'}}</h6>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="insuranceBroker">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Corredor
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.insuranceBroker}}</h6>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="isForBuilding">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Construcción
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.isForBuilding}}</h6>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="contractAmount">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Tamaño Contrato
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.contractAmount | currency : 'CLP'}}</h6>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayCols"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayCols"></tr>
                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="[5, 10, 25 ,100]"></mat-paginator>        
            </div>
            <div class="actions-btn">
                <button (click)="addWarranties()" [disabled]="selection.selected.length === 0" mat-raised-button color="primary">Agregar</button>
            </div>
        </section>  
    </div>
</section>